import React from 'react';
import { Dialog, DialogContent, Box, Button, Typography } from '@mui/material';
import './confirm.scss';

export default function Confirm({
  onConfirm,
  onCancel,
  message,
  confirmLabel = 'Yes',
  cancelLabel = 'No',
}) {
  return (
    <Dialog
      open={true}
      onClose={onCancel}
      maxWidth="sm"
      slotProps={{
        paper: {
          sx: {
            borderRadius: 1,
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
            width: '400px',
            overflow: 'hidden',
          },
        },
      }}
    >
      <DialogContent sx={{ pt: 4, pb: 3, textAlign: 'center' }}>
        <Typography
          align="center"
          sx={{
            fontWeight: 400,
            fontSize: '1rem',
            color: '#333',
            mb: 3,
          }}
        >
          {message ?? 'Please confirm'}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            px: 2,
          }}
        >
          <Button
            onClick={onConfirm}
            variant="contained"
            sx={{
              minWidth: '100px',
              backgroundColor: '#1976d2',
              boxShadow: 'none',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#1565c0',
                boxShadow: 'none',
              },
            }}
          >
            {confirmLabel}
          </Button>
          <Button
            onClick={onCancel}
            variant="outlined"
            sx={{
              minWidth: '100px',
              color: 'black',
              borderColor: 'divider',
              backgroundColor: '#f5f5f5',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#ebebeb',
                borderColor: '#ccc',
                color: 'black',
              },
            }}
          >
            {cancelLabel}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
